import { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { isProductGuideDismissed } from "./productGuideStorage";

/**
 * Abre la guía cuando la URL incluye ?guide=<guideParam> y limpia el query al detectarlo.
 * Si el usuario marcó «no volver a mostrar», no se abre (sí se limpia la URL).
 */
export function useProductGuideQuery(guideParam: string) {
  const location = useLocation();
  const history = useHistory();
  const [showGuide, setShowGuide] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get("guide") !== guideParam) return;

    params.delete("guide");
    const next = params.toString();
    history.replace({
      pathname: location.pathname,
      search: next ? `?${next}` : "",
      hash: location.hash || "",
    });

    if (isProductGuideDismissed(guideParam)) return;

    setShowGuide(true);
  }, [location.pathname, location.search, location.hash, history, guideParam]);

  return {
    showGuide,
    closeGuide: () => setShowGuide(false),
  };
}
